module.exports = __webpack_public_path__ + "img/10.b917f54d.jpg";